<template>
  <div class="c-pagination-buttons flex gap-2">
    <CButton
      class="w-[32px] h-[32px]"
      :disabled="disablePagination || currentPage === 1 || loading"
      round
      @click="emit('page-first')"
    >
      <template #icon>
        <CIcon fa-type="fal" icon="angles-left" size="16px" />
      </template>
    </CButton>
    <CButton
      class="w-[32px] h-[32px]"
      :disabled="disablePagination || currentPage === 1 || loading"
      round
      @click="emit('page-previous')"
    >
      <template #icon>
        <CIcon fa-type="fal" icon="angle-left" size="16px" />
      </template>
    </CButton>
    <CButton
      class="w-[32px] h-[32px]"
      :disabled="disablePagination || currentPage * pageSize >= totalItems || loading"
      round
      @click="emit('page-next')"
    >
      <template #icon>
        <CIcon fa-type="fal" icon="angle-right" size="16px" />
      </template>
    </CButton>
    <CButton
      class="w-[32px] h-[32px]"
      :disabled="disablePagination || currentPage * pageSize >= totalItems || loading"
      round
      @click="emit('page-last')"
    >
      <template #icon>
        <CIcon fa-type="fal" icon="angles-right" size="16px" />
      </template>
    </CButton>
  </div>
</template>

<script setup lang="ts">
import CIcon from '@lib/components/CIcon/CIcon.vue'
import CButton from '@lib/components/CButton/CButton.vue'

defineProps<{
  currentPage: number
  disablePagination?: boolean
  loading?: boolean
  pageSize: number
  totalItems: number
}>()

const emit = defineEmits<{
  (e: 'page-first'): void
  (e: 'page-last'): void
  (e: 'page-next'): void
  (e: 'page-previous'): void
}>()
</script>
